export default [
  {
    key: 'checkbox',
    label: '',
    sortable: false,
    show: true,
    type: 'checkbox',
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'id',
    label: 'ID',
    sortable: true,
    show: false,
    class: 'text-center align-middle',
  },
  {
    key: 'segment_name',
    label: 'Segment Name',
    sortable: true,
    show: true,
    class: 'text-left align-middle text-capitalize',
  },
  {
    key: 'seller',
    label: 'Seller',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'requested_status',
    label: 'Requested Status',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
    type: 'badge',
    color: (e: any) => {
      if (e.requested_status === 'active') {
        return 'success'
      } if (e.requested_status === 'inactive') {
        return 'danger'
      }

      return 'default'
    },
  },
  {
    key: 'cpm',
    label: 'CPM',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
    type: 'currency',
  },
  {
    key: 'program_percent',
    label: 'Program %',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
    type: 'percentage',
  },
  {
    key: 'cpm_cap',
    label: 'CPM Cap',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
    type: 'currency',
  },
  {
    key: 'advertiser_direct_percentage',
    label: 'Advertiser Direct % of',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
    type: 'percentage',
  },
  {
    key: 'ios_reach',
    label: 'IOS Reach',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
    type: 'numeral',
  },
  {
    key: 'android_reach',
    label: 'Android Reach',
    sortable: true,
    show: true,
    class: 'text-center align-middle',
    type: 'numeral',
  },
  //   {
  //     key: 'action',
  //     label: '',
  //     sortable: false,
  //     show: true,
  //     type: 'action_list',
  //     tdClass: 'actions',
  //     thStyle: { width: '160px' },
  //     class: 'text-center align-middle text-capitalize',
  //     thClass: 'align-middle text-center',
  //     actions: [
  //       {
  //         icon: 'pencil',
  //         title: 'Edit',
  //         event: 'edit',
  //         top_level: true,
  //       },
  //     ],
  //   },
]
